import React from 'react'

import { EyebrowType } from '@/fields/eyebrow'
import { StatsCard } from '@/components/StatsCard'

export const ProjectStats: React.FC<{
  eyebrow: EyebrowType
  projectCount: number
  blockchainHeight: number
  totalStorage: number
  className?: string
  flexClassName?: string
  size?: 'lg' | 'md'
}> = (props) => {
  const {
    projectCount,
    blockchainHeight,
    totalStorage,
    eyebrow,
    className,
    flexClassName,
    size = 'md',
  } = props

  return (
    <StatsCard
      size={size}
      className={className}
      flexClassName={flexClassName}
      eyebrow={eyebrow}
      stats={[
        { label: 'Projects built on Sia', value: projectCount.toLocaleString() },
        {
          label: `Blockchain height`,
          value: blockchainHeight.toLocaleString(),
        },
        {
          label: `Total storage`,
          value: `${Number(totalStorage.toFixed(1)).toLocaleString()} TB`,
        },
      ]}
    />
  )
}
